import "./notFound.css";

export const NotFound = () => {
    return(
        <div className="notFoundContainer">
            <p className="BodyText">404: Page not found</p>
        </div>
    )
};